/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import SmileScanMobile from '@brands/Dashboard/Dashboard/Patient/utils/smile_scan_mobile.svg';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectIsAdminLoginNewDesign } from '@brands/store/selectors/isAdminNewDesign';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { setForm } from '@brands/store/slices/patientFormSlice';
import queryString from 'query-string';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../../Components/Button/Button';
import Container from '../../../../Components/Container/Container';
import ProgressBar from '../../../../Components/ProgressBar/ProgressBar';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import styles from './styles.module.scss';

const ImageUploadMobile = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const isAdminNewDesign = useSelector(selectIsAdminLoginNewDesign);
  const { userInfo } = useAppSelector(selectAuth);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const screenSize = useWindowSize();
  const { state } = useLocation();
  const location = useLocation();

  const onBack = (): void => {
    dispatch(setForm([...values!]));
    navigate(-1);
  };

  useEffect(() => {
    const painQuestion = values.find((item) => item.form_question_id === 16)?.value;

    const isPainValid = () => {
      if (!painQuestion) return false;

      const { painLevel, describePain, daysInPain } = painQuestion;

      if (!painLevel) return false;

      if (painLevel !== 'noPain' && (!describePain || (describePain as string[]).length === 0)) return false;

      if (painLevel !== 'noPain' && !daysInPain) return false;

      return true;
    };

    if (!isPainValid()) {
      if (isAdminNewDesign) {
        roleNavigate('/describe-pain-level');
      } else roleNavigate('/describe-pain-level');
    }
  }, [values]);

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
      }}
      childrenStyle={{ zIndex: '2' }}
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.uploadImageContainerDiv}>
          <ProgressBar currentStep={3} totalSteps={4} onBack={onBack} hideStepNumbers />
          <div className={`${styles.formTitle} d-flex mt-3`}>
            {(values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report' ||
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'second_opinion'
              ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report'
                ? 'Attachment upload'
                : 'Attachment Upload *'
              : 'Attachment upload'}
          </div>
          <div className={styles.uploadImageQRContainer}>
            <div>
              {' '}
              <img className={styles.smileScanMobile} src={SmileScanMobile} alt="SmileScanMobile" />
            </div>
            <div className={styles.uploadImageQRContainerText}>
              <span className={styles.uploadImageQRContainerText1}>Guided Image Capture</span>
              <span className={styles.uploadImageQRContainerText3}>
                We’ll guide you through 5 simple photos that will help your Dentist give you the best experience.
              </span>
            </div>
            <div className={styles.btnContainer}>
              <Button
                type="button"
                style={{ width: '245px', height: '46px' }}
                onClick={() =>
                  isAdminNewDesign
                    ? roleNavigate('/upload-image-flow-step-one')
                    : roleNavigate('/upload-image-flow-step-one', {})
                }
              >
                Begin
              </Button>
            </div>
          </div>
          <div className={styles.uploadImageQRFooter}>
            <div className={styles.uploadImageQRFooterText}>
              Already Have Photos?{' '}
              <span className={styles.clickHere}>
                <a
                  onClick={() => roleNavigate('/upload-image-flow')}
                >
                  Tap Here
                </a>
              </span>{' '}
              to upload images of your mouth and teeth from your phone.
            </div>
          </div>
          {(values.find((item) => item.form_question_id === 20)?.value.caseType as string) !== 'one_report' &&
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) !== 'second_opinion' && (
              <div className={styles.btnContainer}>
                <Button
                  type="button"
                  className={styles.skipButton}
                  style={{ width: '245px', height: '46px' }}
                  onClick={() => {
                    const medicalSummaryState = {
                      caseType: state
                        ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string)
                        : '',
                      patientId: selectedPatient?.value || '',
                      shouldSeeLastModal: false,
                      fromPatientIntake: true,
                    };
                    if (isAdminNewDesign) {
                      roleNavigate('/medical-information-summary');
                    } else if (isStaffCaseCreationRole(userInfo.role.name)) {
                      roleNavigate('/medical-information-summary', { state: medicalSummaryState });
                    } else
                      roleNavigate('/medical-information-summary', {
                        state: medicalSummaryState,
                      });
                  }}
                >
                  Skip
                </Button>
              </div>
            )}
        </div>
      </div>
    </Container>
  );
};
export default ImageUploadMobile;
